(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusReviewControllers')
        .controller('RecomUpdateStatusReviewActionPlanController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        $scope.toggleRecommendationFullPrimarySource = function () {
            $scope.ctrlCtxt.showRecomFullPrimarySource = !$scope.ctrlCtxt.showRecomFullPrimarySource;
        }
    }
})();